export default {
  path: '/404',
  name: 'not-found',
  alias: '*',
  component: () => import(/* webpackChunkName: "not-found" */ './NotFound')
}
